// extracted by mini-css-extract-plugin
export default {"wrapper":"Department_wrapper__MR+Ay","content":"Department_content__jzH1U","usersList":"Department_usersList__zrawY"};